import { Button, Stack, Typography, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import {
  createMultipleOffersApi,
  retrieveMaxOfferNumberApi,
} from "../../../components/api/OfferApiService";
import AddCustomerOfferView from "./AddCustomerOfferView";
import CustomerDialog from "./Dialogs/CustomerDialog";
import ManageOfferFieldsDialog from "./Dialogs/ManageOfferFieldsDialog";

const customers = [
  { id: 152456, label: "PT Namora" },
  { id: 5856, label: "ULT Dubai/Mr Lin" },
  { id: 741856, label: "Khatoco" },
  { id: 12854, label: "Wan Ting" },
];

const BULK_APPLY_FIELDS = [
  { key: "company", label: "Company" },
  { key: "offerDate", label: "Offer Date" },
  { key: "validityDate", label: "Validity Date" },
  { key: "documentStatus", label: "Document Status" },
  { key: "status", label: "Status" },
  { key: "statusDeadline", label: "Status Deadline" },
  { key: "offerLink", label: "Offer Link" },
  { key: "numberOfCases", label: "Number Of Cartons" },
  { key: "netWeightPerCase", label: "Net Weight Per Carton" },
  { key: "volume", label: "Volume" },
  { key: "volumeUnit", label: "Volume Unit" },
  { key: "packaging", label: "Packaging" },
  { key: "portOfDischarge", label: "Port Of Discharge" },
  { key: "portOfLoading", label: "Port Of Loading" },
  { key: "buyingPrice", label: "Buying Price" },
  { key: "buyingPriceCurrency", label: "Buying Price Currency" },
  { key: "firstOfferPriceCurrency", label: "First Offer Price Currency" },
  { key: "finalOfferPrice", label: "Final Offer Price" },
  { key: "finalOfferPriceCurrency", label: "Final Offer Price Currency" },
  { key: "incoterm", label: "Incoterm" },
  { key: "paymentTerm", label: "Payment Term" },
  { key: "comment", label: "Comment" },
  { key: "commentOne", label: "Comment One" },
  { key: "commentTwo", label: "Comment Two" },
  { key: "shipment", label: "Shipment" },
  { key: "financeCharge", label: "Finance Charge" },
  { key: "storageCharge", label: "Storage Charge" },
];

const AddCustomerOffer = (props) => {
  const navigate = useNavigate();
  const { setAddView, rows, setRows, newOfferGroupNumber, locatedData, prevLocation } = props;
  const [customerOpt, setCustomerOpt] = useState(customers);
  const [maxOfferGroupNumber, setMaxOfferGroupNumber] = useState();
  const [loading, setLoading] = useState(false);

  const transformData = (data) => {
    return data.map((d) => {
      const {
        finalOfferPrice,
        finalOfferPriceCurrency,
        finalPrice,
        finalPriceCurrency,
        offerGroupNumber,
        offerType,
        numberOfCases,
        netWeightPerCase,
        volume,
        remainingQuantity,
        company,
        offer,
        item,
        id,
      } = d;
      return {
        offerYear: new Date().getFullYear().toString(),
        buyingPrice: finalOfferPrice || finalPrice || null,
        buyingPriceCurrency: finalOfferPriceCurrency || finalPriceCurrency || "USD",
        selectedOffer: offer || d,
        offerGroupNumber: maxOfferGroupNumber,
        offerType: "CUSTOMER",
        company: company,
        itemId: item?.id || null,
        salesGrade: item?.buyingGrade || null,
        salesOrigin: item?.origin || null,
        salesCrop: item?.crop || null,
        salesNicotine: item?.nicotine || null,
        salesSugar: item?.sugar || null,
        item: item ? item : null,
        referenceVendorOfferId: id || null,
        numberOfCases: 
        remainingQuantity && netWeightPerCase !== 0 
          ? remainingQuantity / netWeightPerCase 
          : numberOfCases || null,
        netWeightPerCase: netWeightPerCase || null,
        volume: remainingQuantity || volume || null,
      };
    });
  };
  function getMaxOfferNumber() {
    retrieveMaxOfferNumberApi("CUSTOMER")
      .then((response) => {
        setMaxOfferGroupNumber(response?.data + 1);
      })
      .catch((error) => console.log(error.response?.data));
  }
  useEffect(() => {
    getMaxOfferNumber();
  }, [locatedData]);

  useEffect(() => {
    setAddOfferArray(() => {
      if (locatedData?.selectedData) {
        return transformData(locatedData.selectedData);
      } else {
        return [generateDefaultObject(locatedData)];
      }
    });
  }, [maxOfferGroupNumber]);

  const generateDefaultObject = (locatedData) => ({
    offerYear: new Date().getFullYear().toString(),
    offerGroupNumber: maxOfferGroupNumber,
    orderGroupNumber: null,
    offerStatus: { id: null, label: null },
    offerType: "CUSTOMER",
    stakeholderId: null,
    approvalStatus: null,
    status: null,
    statusDeadline: null,
    item: locatedData?.item || null,
    itemId: locatedData?.item?.id || null,
    salesGrade: locatedData?.item?.buyingGrade || null,
    salesOrigin: locatedData?.item?.origin || null,
    salesCrop: locatedData?.item?.crop || null,
    salesNicotine: locatedData?.item?.nicotine || null,
    salesSugar: locatedData?.item?.sugar || null,
    company: locatedData?.company || null,
    costId: null,
    buyingPrice: locatedData?.buyingPrice || null,
    buyingPriceCurrency: locatedData?.buyingPriceCurrency || "USD",
    firstOfferPrice: null,
    firstOfferPriceCurrency: "USD",
    finalOfferPrice: null,
    finalOfferPriceCurrency: "USD",
    firstSampleId: null,
    secondSampleId: null,
    firstSampleDate: null,
    secondSampleDate: null,
    packaging: null,
    paymentTerm: null,
    numberOfCases: locatedData?.numberOfCases || null,
    netWeightPerCase: locatedData?.netWeightPerCase || null,
    volume: locatedData?.volume || null,
    volumeUnit: "KG",
    offerDate: null,
    offerLink: null,
    referenceVendorOfferId: locatedData?.offer?.id || null,
    selectedOffer: locatedData?.offer || null,
    validityDate: null,
    incoterm: locatedData?.incoterm || null,
    remark: null,
    comment: null,
    documentStatus: null,
    recordStatus: null,
    show: true,
  });

  const [addOfferArray, setAddOfferArray] = useState(() => {
    if (locatedData?.selectedData) {
      return transformData(locatedData.selectedData);
    } else {
      return [generateDefaultObject(locatedData)];
    }
  });

  const [openCustomerDialog, setOpenCustomerDialog] = useState(false);
  const [openManageFieldsDialog, setOpenManageFieldsDialog] = useState(false);

  const applySharedFields = ({ sourceIndex, targetIndexes, selectedFieldKeys }) => {
    if (!Array.isArray(targetIndexes) || targetIndexes.length === 0) {
      return;
    }

    const sourceOffer = addOfferArray[sourceIndex];
    if (!sourceOffer) {
      return;
    }

    setAddOfferArray((prevOffers) =>
      prevOffers.map((offerEntry, idx) => {
        if (!targetIndexes.includes(idx)) {
          return offerEntry;
        }

        const updatedEntry = { ...offerEntry };
        selectedFieldKeys.forEach((fieldKey) => {
          updatedEntry[fieldKey] = sourceOffer[fieldKey] ?? null;
        });

        if (
          (selectedFieldKeys.includes("numberOfCases") ||
            selectedFieldKeys.includes("netWeightPerCase")) &&
          !selectedFieldKeys.includes("volume")
        ) {
          const cases = parseFloat(updatedEntry.numberOfCases);
          const weight = parseFloat(updatedEntry.netWeightPerCase);
          if (!Number.isNaN(cases) && !Number.isNaN(weight)) {
            updatedEntry.volume = cases * weight;
          }
        }

        if (
          selectedFieldKeys.includes("status") &&
          updatedEntry.status !== "First Refusal" &&
          updatedEntry.status !== "Optioned"
        ) {
          updatedEntry.statusDeadline = null;
        }

        return updatedEntry;
      }),
    );

    toast.success("Selected fields were applied to the selected offers.");
  };

  const handleAddAnother = () => {
    addOfferArray.map((offer) => (offer.show = false));
    setAddOfferArray([
      ...addOfferArray,
      {
        offerType: "CUSTOMER",
        offerGroupNumber: maxOfferGroupNumber,
        orderGroupNumber: null,
        offerStatus: { id: null, label: null },
        stakeholderId: null,
        approvalStatus: null,
        status: null,
        statusDeadline: null,
        item: null,
        itemId: null,
        salesGrade: null,
        salesOrigin: null,
        salesCrop: null,
        salesNicotine: null,
        salesSugar: null,
        company: null,
        costId: null,
        buyingPrice: null,
        buyingPriceCurrency: "USD",
        firstOfferPrice: null,
        firstOfferPriceCurrency: "USD",
        finalOfferPrice: null,
        finalOfferPriceCurrency: "USD",
        firstSampleId: null,
        secondSampleId: null,
        firstSampleDate: null,
        secondSampleDate: null,
        packaging: null,
        paymentTerm: null,
        numberOfCases: null,
        netWeightPerCase: null,
        volume: null,
        volumeUnit: "KG",
        offerDate: null,
        offerLink: null,
        validityDate: null,
        incoterm: locatedData?.incoterm || null,
        remark: null,
        comment: null,
        documentStatus: null,
        recordStatus: null,
        offerYear: null,
        show: true,
      },
    ]);
  };

  const isButtonDisabled = addOfferArray.some(
    (record) =>
      ((record.status === "First Refusal" || record.status === "Optioned") &&
      (!record.statusDeadline || record.statusDeadline.trim() === "")) || (!record?.offerDate),
  );

  return (
    <>
      <Stack direcion="column">
        <Typography variant="h5" mb={2}>
          Create New Customer Offer
        </Typography>
        <Stack spacing={1}>
          {addOfferArray?.map((offer, index) => (
            <AddCustomerOfferView
              key={index}
              index={index}
              addOfferArray={addOfferArray}
              setAddOfferArray={setAddOfferArray}
              offer={offer}
              customerOpt={customerOpt}
              setOpenCustomerDialog={setOpenCustomerDialog}
              newOfferGroupNumber={newOfferGroupNumber || maxOfferGroupNumber}
            />
          ))}
        </Stack>

        <Stack direction="row" spacing={1} mt={1}>
          <Button variant="text" onClick={() => handleAddAnother()}>
            + Add another
          </Button>
          <Button
            variant="outlined"
            disabled={addOfferArray.length < 2}
            onClick={() => setOpenManageFieldsDialog(true)}
          >
            Manage Shared Fields
          </Button>
        </Stack>
        <Stack direction="row" spacing={1} mt={1}>
          <Button
            variant="outlined"
            onClick={() => {
              if (prevLocation) {
                navigate(`/${prevLocation}`);
              } else {
                setAddView(false);
              }
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={isButtonDisabled || loading}
            variant="contained"
            onClick={() => {
              const isCurrencyMismatch = addOfferArray.some((offer) => {
                const selectedOffer = offer.referenceVendorOffer?.id
                  ? offer.referenceVendorOffer
                  : offer.selectedOffer;

                return (
                  selectedOffer?.finalOfferPriceCurrency &&
                  offer.finalOfferPriceCurrency !==
                    selectedOffer.finalOfferPriceCurrency
                );
              });

              if (isCurrencyMismatch) {
                const confirm = window.confirm(
                  "The final price currency is not the same as the reference offer's final price currency. Do you want to proceed?",
                );
                if (!confirm) return;
              }
              setLoading(true);
              createMultipleOffersApi(addOfferArray)
                .then((response) => {
                  setLoading(false);
                  toast.success("Customer offer added successfully.");
                  if (rows && setRows) {
                    setRows([...addOfferArray, ...rows]);
                  }
                  if (prevLocation) {
                    navigate(`/${prevLocation}`);
                  } else {
                    navigate("/customer-offer-view");
                    setAddView(false);
                  }
                })
                .catch((error) => {
                  setLoading(false);
                  toast.error(error.response.data.message);
                  console.log(error.response.data);
                });
            }}
          >
           {loading ? <CircularProgress size={24} color="inherit" /> : "Add"}
          </Button>
        </Stack>
        {isButtonDisabled && (
          <Typography style={{ color: "red", marginTop: "10px" }}>
            Please ensure all required fields are completed.
          </Typography>
        )}
      </Stack>

      {openCustomerDialog && (
        <CustomerDialog
          open={openCustomerDialog}
          setOpen={setOpenCustomerDialog}
          customerOpt={customerOpt}
          setCustomerOpt={setCustomerOpt}
        />
      )}

      <ManageOfferFieldsDialog
        open={openManageFieldsDialog}
        setOpen={setOpenManageFieldsDialog}
        offers={addOfferArray}
        fields={BULK_APPLY_FIELDS}
        onApply={applySharedFields}
      />
    </>
  );
};

export default AddCustomerOffer;
